import { css } from 'styled-components';
import { brand2, brand2Dark } from '../../../../../../colors/brand';
import { white, grey400, grey600 } from '../../../../../../colors/greyscale';
import { disabledStyle } from '../../../../../../utils/style';

/**
 * Generates the tertiary button type style.
 */
export const tertiaryTypeStyle = () => css`
  background-color: ${brand2};
  border-color: ${brand2};
  color: ${white};

  &:hover {
    background-color: ${brand2Dark};
  }

  ${disabledStyle(css`
    background-color: ${grey400};
    border-color: ${grey400};
    color: ${grey600};
  `)}
`;
